export const useTableFunctions = () => {
  const sortByKey = <T>(data: T[], key: keyof T, asc: boolean) => {
    const sortedData: T[] = [...data].sort((a, b) => {
      const valueA = a[key];
      const valueB = b[key];

      if (typeof valueA === "string" && typeof valueB === "string") {
        return asc ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }
      if (typeof valueA === "number" && typeof valueB === "number") {
        return asc ? valueB - valueA : valueA - valueB;
      }
      if (valueA < valueB) return asc ? -1 : 1;
      if (valueA > valueB) return asc ? 1 : -1;
      return 0;
    });
    return sortedData;
  };

  return { sortByKey };
};
